import {commentHttpRepository} from '../../repositories/comments-http-repository';

export const readArticleComments = articleId =>
  commentHttpRepository.get(articleId, {order: 'desc'})
    .catch(console.error);
